export default "__VITE_ASSET__b8970c32__"